import { exceedsLimit } from '../../../../helpers/Validation/validationHelpers';
import messages from '../../../../locale/jsonMessages';

const validate = (values) => {
    const errors = {};

    if (values.dynamicReportType) {
        let dynamicReportTypeError = []
        if (values?.dynamicReportType?.map((item, index) => {
            const dynamicNameError = {}
            if (!item?.reportType || item?.reportType.toString().trim() === '') {
                dynamicNameError.reportType = messages.required;
                dynamicReportTypeError[index] = dynamicNameError;
            } else if (exceedsLimit(item?.reportType, 50)) {
                dynamicNameError.reportType = messages.codeRestriction;
                dynamicReportTypeError[index] = dynamicNameError;
            }

            if (!item?.reportContent || item?.reportContent.toString().trim() === '') {
                dynamicNameError.reportContent = messages.required;
                dynamicReportTypeError[index] = dynamicNameError;
            } else if (exceedsLimit(item?.reportContent, 1000)) {
                dynamicNameError.reportContent = messages.reportContentRestriction;
                dynamicReportTypeError[index] = dynamicNameError;
            }

            if (!item?.language || item?.language.toString().trim() === '') {
                dynamicNameError.language = messages.required;
                dynamicReportTypeError[index] = dynamicNameError;
            }
        }));
        if (dynamicReportTypeError?.length > 0) errors.dynamicReportType = dynamicReportTypeError;
    }

    return errors;
};

export default validate;
